import React from 'react';
import { XIcon } from '@heroicons/react/outline';
import { useHistory } from 'react-router-dom';
import { FarmContext } from './FarmContext';
import { AppContext } from './AppContext';
import { format } from 'd3-format';
// import ExtraEditor from './ExtraEditor';
// import { GeoSVG, getArea } from './geo';
import Warning from './Warning';
import { saveFkd, deleteFkd} from './db';
import { DEFAULT_PATH } from './App';
import { BoundaryPropEditor, GenericField, FormField } from './CompProperties';
import Attachments from './Attachments';
import { savedIcon } from './Notifications';


const acF = format('.2s');


function ViewField ({k}) {
  return <GenericField k={k}>
    <p>
      {k.placeholder}
    </p>
  </GenericField>

} 

export function SelectedFKD ({selected}) {
  const { setSelected, toggleShowing } = React.useContext(AppContext);
  const history = useHistory();

  return <div className="w-full p-4">
    <div className="w-full flex justify-center">
      <button
        type="button"
        className="order-1 ml-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-0 sm:ml-0"
        onClick={() => {
          // TODO reconcile the old props/boundary fkd/comp stuff with the state now in appcontext
          setSelected(null);
          toggleShowing('Properties', true);
          // TODO turn on FKD Properties
          history.push(`/fkd/${selected.id}`);
        }}
      >
        Edit
      </button>
      <button
        type="button"
        className="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-1 sm:ml-3"
        onClick={() => setSelected(null)}
      >
        <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
        Cancel
      </button>
    </div>

    <div>
      <ViewField k={{label: 'Category', 'id': 'category', 'placeholder': selected.properties['category']}} />
      <ViewField k={{label: 'Date', 'id': 'date', 'placeholder': selected.properties['date']}} />
      <ViewField k={{label: 'Acres', 'id': 'acres', 'placeholder': acF(selected.properties['acres'])}} />
      <ViewField k={{label: 'Notes', 'id': 'notes', 'type': 'Text', 'placeholder': selected.properties['notes']}} />
    </div>

  </div>
}


export default function FKDProperties() {
  const { fkdId, boundary, setBoundary, formData } = React.useContext(FarmContext);
  const { user, notify } = React.useContext(AppContext);
  const history = useHistory();

  const saveToServer = React.useCallback(() => {
    
    notify('Knowledge Successfully Saved', 'You can share it using the url.', savedIcon);
    saveFkd(user, fkdId, formData, boundary)
      .then(f => {
        console.log(f)
        history.push('/fkd/' + f.id);

      });
  }, [user, fkdId, boundary, formData, history, notify]);

  const deleteButton = React.useCallback(() => {
    const del = window.confirm('Are you sure you want to delete this knowledge?')
    if (del) {
      notify('Knowledge Successfully Deleted', '', savedIcon);
      deleteFkd(user, fkdId).then(f => {
          history.push(DEFAULT_PATH);
        });
    }
  }, [user, fkdId, history, notify]);


  if (boundary.features.length === 0) return <Warning text="No farm boundary, go and draw one on the farm map." />

  const credit = (fkdId === 'new') ? 'Create' : 'Edit';
  const lupdate = formData.source_user ? `Last update: ${formData.source_user} on ${formData.updated_at && formData.updated_at.slice(0, 10)}` : '';

  // TODO standardize frame
  return <div className="w-full max-w-2xl" >
    <div className="pt-4 space-y-6 sm:pt-10 sm:space-y-5">
      <div>
        <h3 className="text-lg leading-6 font-medium text-gray-900">FKD Properties</h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">{credit} a Farm knowledge Data entry. {lupdate}</p>
      </div>

      <FormField k={{label: 'Category', 'id': 'category'}} />
      <FormField k={{label: 'Notes', 'id': 'notes', 'type': 'Text'}} />
      <FormField k={{label: 'Source', 'id': 'source'}} />
      <FormField k={{label: 'Date', 'id': 'date', 'type': 'Date'}} />

      <GenericField k={{id: 'Attachments'}} >
         <Attachments model='knowledge' />
      </GenericField>

      {/*<FormField k={{'id': 'extra', 'type': 'Object'}} />*/}

      <h3 className="text-lg leading-6 font-medium text-gray-900">Boundary Properties</h3>

      {boundary.features.map(f => {
        return <BoundaryPropEditor key={f.id} f={f} updateProps={newProps => {
          setBoundary(fc => ({...fc, features: fc.features.map(fOld => {
            if (fOld.id === f.id) return {...fOld, properties: newProps};
            return fOld;
          })}))
        }} />
      })}

    <div className="pt-5">
      <div className="flex justify-end">
        {(fkdId !== 'new') && <button
          className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
          type="button"
          onClick={deleteButton}
        >
          Delete
        </button>}

        <button
          className="ml-4 shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
          type="button"
          onClick={saveToServer}
        >
          Save
        </button>
      </div>
    </div>

    </div>
  </div>
}